type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const FitnessIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="2" y1="12" x2="22" y2="12" />
    <rect x="4" y="8" width="3" height="8" rx="1" />
    <rect x="17" y="8" width="3" height="8" rx="1" />
    <rect x="7" y="6" width="2" height="12" rx="1" />
    <rect x="15" y="6" width="2" height="12" rx="1" />
  </svg>
);
